import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useRefreshStore from "./useRefreshStore";
import { BASE_URL, createHeaders } from "../../config/create-header";
import { apiUrl } from "../../config/apiUrls";

export const useSessionManager = (id, navLink, API_URL) => {
  const navigate = useNavigate();
  const { hasRefreshed, setHasRefreshed } = useRefreshStore();

  const checkSession = async () => {
    if (!id) {
      navigate(navLink, { replace: true });
      return;
    }

    try {
      const response = await fetch(`${BASE_URL}${apiUrl[API_URL]}`, {
        method: "POST",
        // headers: createHeaders(),
        body: JSON.stringify({ uniqueId: id })
      });

      if (!response.ok) {
        navigate(navLink, { replace: true });
        return;
      }

      const data = await response.json();
      if (!data?.find) {
        navigate(navLink, { replace: true });
      }
    } catch (error) {
      navigate(navLink, { replace: true });
    }
  };

  useEffect(() => {
    // checkSession();

    const handleBeforeUnload = (event) => {
      event.preventDefault();
      setHasRefreshed(true);
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [id]);

  useEffect(() => {
    if (hasRefreshed) {
      setHasRefreshed(false); // Reset for next time
      navigate(navLink);
    }
  }, [hasRefreshed]);

  return { hasRefreshed };
};
